angular.module('mymessages').config(['AppRoutesProvider', '$stateProvider', '$urlRouterProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var portalSettings = { toolbarItem: 'messages' };

        var appRoutes = {
            'myMessages': {
                state: 'myMessages',
                route: '/my-messages',
                portalSettings: portalSettings
            },
            'myMessagesNewMessage': {
                state: 'myMessages.myMessagesNewMessage',
                route: '/new-message',
                portalSettings: portalSettings
            },
            'myMessagesDisplayMessages': {
                state: 'myMessages.myMessagesDisplayMessages',
                route: '/display-messages/:displayMode',
                portalSettings: portalSettings
            },
            'myMessagesDisplayMessageThread': {
                state: 'myMessages.myMessagesDisplayMessageThread',
                route: '/display-message-thread/:displayMode?id?updateNotification',
                portalSettings: portalSettings
            },
            'myMessagesMobile': {
                state: 'myMessagesMobile',
                route: '/my-messages-mobile/:displayMode',
                portalSettings: portalSettings
            },
            'myMessagesMobileNewMessage': {
                state: 'myMessagesMobile.myMessagesNewMessage',
                route: '/new-message',
                portalSettings: portalSettings
            },
            'myMessagesMobileDisplayMessageThread': {
                state: 'myMessagesMobile.myMessagesDisplayMessageThread',
                route: '/display-message-thread/:displayMode?id?updateNotification',
                portalSettings: portalSettings
            }
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.myMessages.state, {
                url: appRoutes.myMessages.route,
                templateUrl: '/mymessages/views/myMessages.html',
                controller: 'MyMessagesCtrl',
                description: '/myMessages',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Messages'); }
                }
            })
            .state(appRoutes.myMessagesNewMessage.state, {
                url: appRoutes.myMessagesNewMessage.route,
                templateUrl: '/mymessages/views/newMessage.html',
                controller: 'NewMessageCtrl',
                description: '/NewMessages'
            })
            .state(appRoutes.myMessagesDisplayMessages.state, {
                url: appRoutes.myMessagesDisplayMessages.route,
                templateUrl: '/mymessages/views/displayMessages.html',
                controller: 'DisplayMessagesCtrl',
                description: '/DisplayMessages'
            })
            .state(appRoutes.myMessagesDisplayMessageThread.state, {
                url: appRoutes.myMessagesDisplayMessageThread.route,
                templateUrl: '/mymessages/views/displayMessageThread.html',
                controller: 'DisplayMessageThreadCtrl',
                description: '/DisplayMessageThread'
            })
            .state(appRoutes.myMessagesMobile.state, {
                url: appRoutes.myMessagesMobile.route,
                templateUrl: '/mymessages/views/myMessagesMobile.html',
                params: { folder: 'inbox' },
                controller: 'MyMessagesMobileCtrl',
                description: '/myMessagesMobile'
            })
            .state(appRoutes.myMessagesMobileNewMessage.state, {
                url: appRoutes.myMessagesMobileNewMessage.route,
                templateUrl: '/mymessages/views/newMessage.html',
                controller: 'NewMessageMobileCtrl',
                description: '/NewMessages'
            })
            .state(appRoutes.myMessagesMobileDisplayMessageThread.state, {
                url: appRoutes.myMessagesMobileDisplayMessageThread.route,
                templateUrl: '/mymessages/views/displayMessageThread.html',
                controller: 'DisplayMessageThreadMobileCtrl',
                description: '/DisplayMessageThread'
            });
    }]);